import LoginComponent from "../components/smart/LoginComponent";

function HomePage() {
    return (
        <div className="row mt-5">
            <div className="col-lg-4 col-sm-12">

            </div>
            <div className="col-lg-4 col-sm-12">
                <img alt="site-logo" src="https://prepfortech.in/wp-content/uploads/elementor/thumbs/cropped-prepForTechLogo-4-p9gm5dxr37nhqhvs25rdb1bh3zpqhtfhyfsmpq2ig8.png" />
                <h4 style={{ paddingLeft: '30%' }}> Sales Dashboard Login </h4>
                <div style={{ paddingLeft: '30%' }}>
                    <LoginComponent />
                </div>
            </div>
            <div className="col-lg-4 col-sm-12">

            </div>
        </div>
    )
}

export default HomePage;